import { SignUp } from '@develio/auth/client';
import { Navigate } from 'react-router-dom';

/** While waitlist mode is on, new signups are blocked and funneled to the
 * public waitlist. Flip VITE_WAITLIST_MODE in Vercel to toggle. */
const WAITLIST_MODE = import.meta.env.VITE_WAITLIST_MODE === 'true';

export function SignUpRoute() {
  if (WAITLIST_MODE) {
    return <Navigate to="/waitlist" replace />;
  }
  return (
    <div className="flex min-h-screen items-center justify-center bg-slate-50 px-4">
      <div className="w-full max-w-md">
        <div className="mb-6 text-center">
          <h1 className="text-2xl font-semibold tracking-tight">Develio</h1>
          <p className="mt-1 text-sm text-slate-500">Economic Development Tools</p>
        </div>
        <SignUp routing="path" path="/sign-up" signInUrl="/sign-in" />
      </div>
    </div>
  );
}
